import Container from "saur_ui_library/src/Atoms/Container/Container";
import { EventsPluieApi } from "../../api";
import React, {ReactElement} from "react";
import MaterialTableComponent from "../../../components/module/table/materialTableComponent";
import { Styles } from "../../../Views/PluieDetail";
import { columnComponent, dataEventsColumnsPluieDetail } from "../table/tableHelper";
import { createRows, transformDataPeriodicities } from "../view/pluieDetailHelper";

 // get data for intensity graphic
export const getDataQuantity = async (pData: any) => {
    let response;
    try {
      const event = await EventsPluieApi.getSpecificEventForQuantity(
        pData.dumpedTreshold,
        pData.mainInstallCode,
        pData.startDateForRequest,
        pData.endDateForRequest
        //toEndOfDayUTC(pData.endDateForRequest)
      );
      response = event.data;
    } catch (error) {
      response = [];
      console.log(
        'Erreur lors de la récupération des événements pluvieux de quantité',
        error
      );
    }
    return response;
  };

  const toEndOfDayUTC = (isoDate: string) => {
    return isoDate.replace('T00:00:00Z', 'T23:59:00Z');
  };  

 export const getDataVolume = async (pData: any) => {
    let response;
    try {
      const event = await EventsPluieApi.getSpecificEventForVolume(
        pData.mainInstallCode,
        pData.startDateForRequest,
        pData.endDateForRequest
        //toEndOfDayUTC(pData.endDateForRequest)
      );
      response = event.data;
    } catch (error) {
      response = [];
      console.log(
        'Erreur lors de la récupération des événements pluvieux de volume',
        error
      );
    }
    return response;
  };

 //render for envets table
 export const renderTable = (dataTable: any[], onChangeRadio: Function): ReactElement => {
    const columns = dataEventsColumnsPluieDetail;
    columns[5] = columnComponent(
      'none',
      {
        minWidth: 35,
        accessorKey: 'milieu-detail',
        size: 10,
        enableSorting: false,
      },
      (row: any) => {
        return (
          <input
            id={'radio-' + row.row.original.id}
            type='radio'
            name='eventsSelectionInput'
            onChange={(e) => onChangeRadio(e, row.row.original)}
          ></input>
        );
      }
    );

    return (
      <Container className='hydroDetail-parameterClass'>
        <Styles />
        <Container className='hydroDetailContentContainer'>
          <Container className='hydroDetailContainer'>
            <MaterialTableComponent
              columns={columns}
              rows={dataTable}
              rowsPerPage={20}
            />
          </Container>
        </Container>
      </Container>
    );
  };

// get pluvio events hence periodicity selected
export const getPluivoEvents = async (pOption: any, mainInstallCode: string) => {
    let response;
    try {
      const events = await EventsPluieApi.getEvents(
        mainInstallCode,
        pOption.monthId,
        pOption.year
      );
      response = events.data;
    } catch (error) {
      response = [];
      console.log(
        'Erreur lros de la récupération des événements pluvieux',
        error
      );
    }
    return createRows(response);
  };

  // Sort Noise Date depending on RecordDate
  export const periodicitiesSortedByDate = (pDataToSort: any) => {
    return pDataToSort.sort((a, b) => {
      const dateA = new Date(a.year + ',' + a.monthId);
      const dateB = new Date(b.year + ',' + b.monthId);
      return dateB.getTime() - dateA.getTime();
    });
  };

  export const rainEventsSortedByDate = (pDataToSort: any) => {
    return pDataToSort.sort((a, b) => {
      const dateA = new Date(a.startDateForRequest);
      const dateB = new Date(b.startDateForRequest);
      return dateB.getTime() - dateA.getTime();
    });
  };

export  const getPeriodicities = async (mainInstallCode:string) => {
    let periodicities;
    try {
      const times = await EventsPluieApi.getPeriodicities(mainInstallCode);
      const dataSorted = periodicitiesSortedByDate(times.data);
      periodicities = transformDataPeriodicities(dataSorted);
    } catch (error) {
      periodicities = [];
      console.log('Erreur lors de la récupération des périodicités', error);
    }
    return periodicities;
  };